import { Flex } from "@otrium/core";
import styled from "@emotion/styled";

const ButtonsContainer = styled(Flex)`
  padding: ${({ theme }) => theme.space.space16};
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
  background-color: ${({ theme }) => theme.colors.tone.white};
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => theme.space.space16};
`;

export { ButtonsContainer };
